<template>
    <section>
        <div class="t-body3 mgt-6 t-color-content1" v-html="$t('64', {str1: '', str2: `<span class='t-color-red1'><strong>${findId.loginId}</strong></span>`})">
            <!-- 가입하신 이메일 계정은<br>
            <span class="bold t-color-red1">{{findId.loginId}}</span> 입니다. -->
        </div>
        <div class="mgt-50">
            <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="$moveLogin()">
                {{$t('65')}}
                <!-- 로그인 -->
            </button>
        </div>
        
    </section>
</template>

<script>
/**
 * 계정 찾기 완료 컴포넌트 (find account complete component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState('findId',{
            findId : state => state,
        }),
    },

    mounted() {
        this.setMaterialUi()
    },

    methods: {
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    },
}
</script>